var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7255 15.3846V16.0577C12.7255 16.7717 12.4384 17.4565 11.9273 17.9614C11.4163 18.4663 10.7232 18.75 10.0005 18.75C9.2778 18.75 8.5847 18.4663 8.07367 17.9614C7.56264 17.4565 7.27555 16.7717 7.27555 16.0577V15.3846M17.3102 14.0145C16.2168 12.6923 15.4449 12.0192 15.4449 8.3741C15.4449 5.03606 13.7197 3.84681 12.2997 3.26923C12.1111 3.19267 11.9335 3.01683 11.876 2.82542C11.627 1.98786 10.9287 1.25 10.0005 1.25C9.07232 1.25 8.37362 1.98828 8.1271 2.82626C8.06962 3.01977 7.89207 3.19267 7.70345 3.26923C6.28179 3.84766 4.55825 5.03269 4.55825 8.3741C4.55612 12.0192 3.78419 12.6923 2.6908 14.0145C2.23777 14.5622 2.6346 15.3846 3.42696 15.3846H16.5783C17.3664 15.3846 17.7607 14.5597 17.3102 14.0145Z",
    stroke: "#001A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a30bb3e6.svg";
export { ForwardRef as ReactComponent };